module.exports = __webpack_public_path__ + "assets/img/PC3.0c6aedd9.jpg";